var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66669 17.7179C2.66669 14.5024 5.17057 11.863 8.30824 11.7148L8.58669 11.7082H14.9734V19.8478C14.9734 20.4311 15.4267 20.8923 16 20.8923C16.5134 20.8923 16.9483 20.5048 17.0172 19.9909L17.0267 19.8478V11.7082H23.4C26.5734 11.7082 29.1805 14.2558 29.3269 17.4606L29.3334 17.7451V24.3516C29.3334 27.5803 26.8295 30.2201 23.6918 30.3683L23.4134 30.3749H8.60002C5.41373 30.3749 2.81882 27.8145 2.67314 24.6214L2.66669 24.3381V17.7179ZM11.4003 8.3213C11.0245 7.95767 10.9904 7.38466 11.2878 6.98296L11.387 6.86797L15.267 2.97464C15.467 2.77464 15.7203 2.66797 16.0003 2.66797C16.2136 2.66797 16.427 2.73624 16.5993 2.86594L16.7203 2.97464L20.6003 6.86797C20.8003 7.06797 20.907 7.33464 20.907 7.58797C20.907 7.85464 20.8003 8.1213 20.6003 8.3213C20.2367 8.68494 19.6636 8.718 19.2619 8.42048L19.147 8.3213L17.027 6.18797V11.708H14.9736V6.18797L12.8536 8.3213C12.4536 8.7213 11.8003 8.7213 11.4003 8.3213Z",
    fill: "#B3B3B3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.b8fd0e517c2d0125c75c941a5750515b.svg";
export { ForwardRef as ReactComponent };